export enum PolicyStates {
    ACTIVE = '1',
    INACTIVE = '2',
    CANCELED = '3',
    SOON_TO_EXPIRE = '4',
    IS_RENEWAL = '5',
    IS_WITHDRAWAL_REQUEST = '6',
}